module.exports = __webpack_public_path__ + "ea8f5b47505d5c38e3f56a9170022abf.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sound/loops/loop3.wav
// module id = 88
// module chunks = 0